import { type ReactNode } from 'react';

export type RenderComponent<T> = ((props: T) => ReactNode) | ReactNode;

export type RenderComponentProps<T> = {
  children: RenderComponent<T>;
} & T;

/** Will render the component or a function with the proper props in a render prop. */
const renderComponent = <T extends object>(props: RenderComponentProps<T>) => {
  const { children, ...rest } = props;

  if (typeof children === 'function') return children({ ...rest } as T);

  return children;
};

export default renderComponent;
